import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { AlertError } from '../../components/bootstrap/AlertError';
import { AddTermOfAcceptForm } from '../../components/candidature/AddTermOfAcceptForm';
import Loading from '../../components/general/Loading';
import { SubTemplate } from '../../components/general/SubTemplate';
import { DocumentType } from '../../models/DocumentType';
import {getTermOfAccept, submitTermOfAccept} from '../../rest/candidature';
import { listDocumentsByTypeAndCandidatureExternalId } from '../../rest/document';
import { handleError, isNotBusinessError } from '../../utils/handleError';

export function CandidatureSubmitTermOfAccept() {
  const { externalId } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userDocuments, setUserDocuments] = useState([]);
  const [term, setTerm] = useState([]);
  const [submit, setSubmit] = useState(false);

  async function fetchData() {
    try {
      const [{ data: userDocuments },{data:termIn}] = await Promise.all([
        await listDocumentsByTypeAndCandidatureExternalId(
          DocumentType.TERM_ACCEPT,
          externalId
        ),
          await getTermOfAccept(externalId)
      ]);
      setUserDocuments(userDocuments);
      setTerm(termIn);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  if (submit) {
    return <Navigate replace to={`/candidatura/${externalId}`} />;
  }

  async function submitTerms(values) {
    try {
      console.log(externalId)
      await submitTermOfAccept(externalId,values);
      setSubmit(true);
    } catch (error) {
      setError(error);
    }
  }

  function handleSubmit(values) {
    console.log(values)
    submitTerms(values);
  }

  if (loading) {
    return <Loading />;
  }

  if (error && isNotBusinessError(error)) {
    return handleError(error);
  }

  return (
    <SubTemplate>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-8 offset-lg-2 mb-5'>
            <AlertError error={error} />
            <AddTermOfAcceptForm
                term={term}
              onSubmit={handleSubmit}
              userDocuments={userDocuments}
              externalId={externalId}
              setDocuments={setUserDocuments}
            />
          </div>
        </div>
      </div>
    </SubTemplate>
  );
}
